import React from "react";
import { useCountdownStore } from "../../../../stores/use-countdown-store";
import { StyledEditableInput } from "../../../../components/inline-edit/styled";

function EditableLine({ value, propKey, isEditable }) {
  const { setData } = useCountdownStore((state) => ({
    setData: state.setData,
  }));

  return (
    <>
      {isEditable ? (
        <StyledEditableInput
          size={value.length - 1}
          value={value}
          onChange={(e) => setData({ [propKey]: e.target.value })}
        />
      ) : (
        value
      )}
    </>
  );
}

export default EditableLine;
